import { fetchApi } from '@/config/axiosSetting';
import { GetPreviousCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPreviousCorrectiveImages/getPreviousCorrectiveImages.type';
import { GetPreviousCorrectiveImageResponse } from '@/modules/adjusterReportModules/IncidentParticipants/types/images';

export const getPreviousCorrectiveImagesFunction = (
  params: GetPreviousCorrectiveImagesType,
): Promise<GetPreviousCorrectiveImageResponse> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/images/corrective/request/list/`,
    {
      params: {
        damaged_id: params.damaged_id,
      },
    },
  );
};
